import {ValueObject} from '@s-ui/domain'

export class ErrorsPublishDraftValueObject extends ValueObject {}
